export const environment = {
  production: true,
  appVersion: 'v8.0.27',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appHTMLIntegration: 'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl: 'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
  chat_FE_URL: 'https://webchat.sentrixbar.com/login',
  googleMapsApiKey: '',
  // apiUrl: 'mysite.com/api',
  preSignedDomain: 'assets.dev.mobilesentrix.com',
//chat urls start
   CHAT_USER_DATA_KEY: 'chat-user',
   chatUrl:'https://api-chat.sentrixbar.com',    //chat dev url: for chats (like get all groups, post chat etc.)'
   wsChatUrl: 'wss://api-chat-uat.techbar.com/',
   X_User_Id: 'X-User-Id',
   X_Auth_Token: 'X-Auth-Token',
   App_id:'asdwww',
   CHAT_USER_DEFAULT_PASSWORD: '123456',
   CHAT_GQ_LOGIN_WS_URL: 'wss://hrms-api4.0.sentrixbar.com/api', // subscription dev
   //chat urls end
   userChatImageUrl:'https://techbar-chat.s3.amazonaws.com/{avatarID}/avatar.png',



  pdfSignAppUrl: 'https://pdf.sentrixbar.com',



  appDemos: {
   'demo1': {
     'title': 'Demo 1',
     'description': 'Default Dashboard',
     'published': true,
     'thumbnail': './assets/media/demos/demo1.png'
   },



   'demo2': {
     'title': 'Demo 2',
     'description': 'SaaS Application',
     'published': false,
     'thumbnail': './assets/media/demos/demo2.png'
   },



   'demo3': {
     'title': 'Demo 3',
     'description': 'New Trend',
     'published': false,
     'thumbnail': './assets/media/demos/demo3.png'
   },



   'demo4': {
     'title': 'Demo 4',
     'description': 'Intranet Application',
     'published': false,
     'thumbnail': './assets/media/demos/demo4.png'
   },



   'demo5': {
     'title': 'Demo 5',
     'description': 'Support Forum',
     'published': false,
     'thumbnail': './assets/media/demos/demo5.png'
   },



   'demo6': {
     'title': 'Demo 6',
     'description': 'Admin Backend',
     'published': false,
     'thumbnail': './assets/media/demos/demo6.png'
   },



   'demo7': {
     'title': 'Demo 7',
     'description': 'CRM Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo7.png'
   },



   'demo8': {
     'title': 'Demo 8',
     'description': 'Core Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo8.png'
   },



   'demo9': {
     'title': 'Demo 9',
     'description': 'Fancy Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo9.png'
   },



   'demo10': {
     'title': 'Demo 10',
     'description': 'Modern Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo10.png'
   },



   'demo11': {
     'title': 'Demo 11',
     'description': 'Light Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo11.png'
   },



   'demo12': {
     'title': 'Demo 12',
     'description': 'Reporting System',
     'published': false,
     'thumbnail': './assets/media/demos/demo12.png'
   },



   'demo13': {
     'title': 'Demo 13',
     'description': 'Classic Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo13.png'
   },



   'demo14': {
     'title': 'Demo 14',
     'description': 'Creative Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo14.png'
   },



   'demo15': {
     'title': 'Demo 15',
     'description': 'Minimalistic Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo15.png'
   },



   'demo16': {
     'title': 'Demo 16',
     'description': 'Modern Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo16.png'
   },



   'demo17': {
     'title': 'Demo 17',
     'description': 'Backend System',
     'published': false,
     'thumbnail': './assets/media/demos/demo17.png'
   },



   'demo18': {
     'title': 'Demo 18',
     'description': 'System Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo18.png'
   },



   'demo19': {
     'title': 'Demo 19',
     'description': 'Light Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo19.png'
   },



   'demo20': {
     'title': 'Demo 20',
     'description': 'Monochrome Dashboard',
     'published': false,
     'thumbnail': './assets/media/demos/demo20.png'
   },
  },
  graphqlURI:localStorage.getItem('serverURL')??'https://hrms-api4.0.sentrixbar.com/api',
  restURI:localStorage.getItem('restURL')??'https://hrms-api4.0.sentrixbar.com/',
  graphql_WS_URI: 'wss://hrms-api4.0.sentrixbar.com/api',
  accountingApiBaseURI : 'https://api-accounting.sentrixbar.com/',
  SERVER_URL:'https://hrms-api4.0.sentrixbar.com/v1',
  videoCallingAppURL:'https://meet.sentrixbar.com/',
  SaplingApiKey : 'WBGVDCHR03FCWKFRQB5SJPZA7FA9D9CN',
  agoraAppId: 'b0e2311e88ef498b8a729eba23b2e395',
  certificateId: 'a320e21077ac4b85ac7b4600baa19a12',
  customerKey: '018710bde71b4cc683c2e93e45c34afc',
  customerSecret: 'fcdfdd8cf2234b4a86a5e3a6717189c0',



firebase: {
   apiKey: "AIzaSyCe2w7r5o3mf-0Zq0LyvqNWR9D28go5MVw",
   authDomain: "winged-precept-247710.firebaseapp.com",
   projectId: "winged-precept-247710",
   storageBucket: "winged-precept-247710.appspot.com",
   messagingSenderId: "242922632816",
   appId: "1:242922632816:web:d2c01b44845b60f9f726b5",
   measurementId: "G-BVPNB396EL",
   vapikey: "BN_PSXKUArQ6qElByUXwWEMogSzRzivJ8CAOMaEIgDe3MUAKTcd32Xu0Fz_xcfFIgPNShP23lp3rj_Qq2sTBpAM"
  },
};
